import { Link, useLocation } from 'react-router-dom';

export function OrderConfirmationPage() {
  const location = useLocation();
  const orderData = location.state as { orderId?: string; total?: number } | null;

  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="container max-w-2xl">
        <div className="bg-white rounded-xl shadow-sm border p-8 text-center">
          {/* Success icon */}
          <div className="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center">
            <CheckIcon className="w-10 h-10 text-green-600" />
          </div>

          <h1 className="mt-6 text-2xl font-bold text-gray-900">
            ¡Pedido Confirmado!
          </h1>

          <p className="mt-2 text-gray-600">
            Gracias por tu compra. Hemos recibido tu pedido y te enviaremos un correo con los detalles.
          </p>

          {orderData?.orderId && (
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500">Numero de pedido</p>
              <p className="text-lg font-semibold text-gray-900">{orderData.orderId}</p>
            </div>
          )}

          <div className="mt-8 space-y-4">
            <div className="flex items-center gap-4 p-4 bg-orange-50 rounded-lg text-left">
              <span className="text-2xl">📧</span>
              <div>
                <p className="font-medium text-gray-900">Confirmacion por email</p>
                <p className="text-sm text-gray-600">
                  Recibiras un correo con los detalles de tu pedido
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 bg-orange-50 rounded-lg text-left">
              <span className="text-2xl">📦</span>
              <div>
                <p className="font-medium text-gray-900">Seguimiento de envio</p>
                <p className="text-sm text-gray-600">
                  Te notificaremos cuando tu pedido sea enviado
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/pedidos" className="btn btn-secondary">
              Ver mis pedidos
            </Link>
            <Link to="/" className="btn btn-primary">
              Seguir comprando
            </Link>
          </div>
        </div>

        {/* Help section */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            ¿Tienes preguntas sobre tu pedido?
          </p>
          <a
            href="mailto:info@petmas.pe"
            className="text-sm text-orange-500 hover:text-orange-600"
          >
            Contacta a nuestro equipo de soporte
          </a>
        </div>
      </div>
    </div>
  );
}

function CheckIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 13l4 4L19 7"
      />
    </svg>
  );
}
